import { appConfig as $config } from '../../app.config';
import { App } from '../App';
import { Util } from '../Util';
import { SortFilter } from '../SortFilter';
import { Common } from '../Common';
import { addPngFileDialog } from './addFileDialog';

export const UI = (function () {
  let $inSwitch = false,
    $inContSwitch = false,
    $pagewrap = $('#pagewrap'),
    $page = $('#page');

  let init = () => {
    KTUtil.ready(function () {
      KTLayout.init();
    });

    // Toggle aside
    asideToggler();

    // Select2 default settings
    $.fn.select2.defaults.set('minimumResultsForSearch', -1);
    $.fn.select2.defaults.set('width', '100%');

    // Fix stack modal dialogs
    modalFix();
  };

  let pagewrap = (template, data = {}) => {
    return new Promise((resolve, reject) => {
      if ($inSwitch || $inContSwitch) resolve();
      else $inSwitch = true;

      beforePageInit(data, true);

      if (!$config.APP_REACT) {
        $pagewrap.html(template(data));
      }
      $page = $('#page');

      onPageWrapInit();

      $inSwitch = false;

      resolve();
    });
  };

  let page = (template, data = {}, scrollTop = true) => {
    return new Promise((resolve, reject) => {
      if ($inContSwitch) return reject();
      else $inContSwitch = true;

      $page = $('#page');

      if ($config.APP_REACT && !$page.length) {
        return reject('Target element not found');
      }

      beforePageInit(data);

      // Destroy filters
      SortFilter.destroy();

      $page.empty().html(template(data)); //$$Tmpl.Page[pagename](data)

      onPageInit(scrollTop);

      setAsideMenuActive();

      $inContSwitch = false;

      return resolve();
    });
  };

  let render = (selector, template, data = {}, scrollTop = true) => {
    return new Promise((resolve, reject) => {
      if ($inContSwitch) return reject();
      else $inContSwitch = true;

      App.pageData(_.extend(App.pageData(), data));

      $(selector).empty().html(template(data));

      onPageInit(scrollTop);

      $inContSwitch = false;

      return resolve();
    });
  };

  let beforePageInit = (data, start = false) => {
    // Init event "pagerender"
    window.dispatchEvent(new Event('pagerender:start'));

    // Set html page attributes
    currentPageAttr();

    // Close all dialogs
    bootbox.hideAll();

    // Set Page Data
    App.pageDataInit(data, start);
    data.$lang = window['$lang'];
  };

  let onPageInit = (scrollTop) => {
    // Init event "pagerender"
    window.dispatchEvent(new Event('pagerender:complete'));

    // Get and pass marked items
    markedItem();

    $('[data-toggle="tooltip"]').tooltip();

    $('[data-toggle="popover"]').popover();

    dataBinder.dataBind(document.body, window);

    //$router.updatePageLinks();

    $('[data-navigo]').each(function () {
      $(this)
        .off()
        .on('click', (e) => {
          e.preventDefault();
          const target = $(this).attr('href');
          $router.push(target);
        });
    });

    if (!$('.modal:visible').length && scrollTop) {
      $(window).scrollTop(0);
    }

    /*if($('#appsidenavigation').length){
      $('#appsidenavigation a').on('click', () => {
        $router.pause();
      });
    }*/
  };

  let currentPageAttr = () => {
    let rout = document.location.pathname.split('/');
    let currentrout = rout[1];
    let currentaction = rout[rout.length - 1];
    $('body').attr('current-page', currentrout).attr('current-action', currentaction);
  };

  let block = (target) => {
    return KTApp.block(target, {
      opacity: 0.5,
      overlayColor: '#ffffff',
      type: '',
      size: 'lg',
      state: 'brand',
      centerX: true,
      centerY: true,
      message: '',
      shadow: true,
      width: 'auto'
    });
  };

  let unblock = (target) => {
    return KTApp.unblock(target);
  };

  let blockPage = () => {
    return KTApp.block('body', {
      opacity: 0.5,
      overlayColor: '#000000',
      type: '',
      size: 'lg',
      state: 'light',
      centerX: true,
      centerY: true,
      message: '',
      shadow: true,
      width: 'auto'
    });
  };
  let unblockPage = () => {
    return unblock('body');
  };

  let btn = {
    spinnerRight: (btn) => {
      Util.get$(btn).addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);
    },
    spinnerStop: (btn) => {
      Util.get$(btn)
        .removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light')
        .attr('disabled', false);
    },
    spinnerStopAll: () => {
      $('button.kt-spinner')
        .removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light')
        .attr('disabled', false);
    }
  };

  let animation = {
    flipInX: (el) => {
      Util.animateClass(el, 'flipInX animated');
    },
    fadeIn: (el) => {
      Util.animateClass(el, 'fadeIn animated');
    }
  };

  let alert = {
    inForm: (msg, form, type = 'danger', removeFirst = true) => {
      let $form = Util.get$(form);
      if (removeFirst) {
        $('.alert', $form).remove();
      }
      let tmpl = require('./tmpl/alert.hbs');
      $form.prepend(tmpl({ msg: msg, type: type }));
    }
  };

  let errorMessage = (text, title = 'Error', callback = false, additionalButtons = null, size = null) => {
    if ($.isArray(text)) {
      text = $.map(text, function (o) {
        return $.isPlainObject(o) && o.Message ? o.Message : o;
      }).join('<br>');
    }
    bootbox.dialog({
      title: title,
      closeButton: false,
      message: `<h4 class="text-danger">${text}</h4>`,
      className: 'modal-danger erroralert-dialog-modal',
      size: size,
      buttons: Object.assign({
        Ok: {
          label: 'OK',
          className: 'btn btn-brand',
          callback: function () {
            UI.btn.spinnerStopAll();
            if (callback) callback();
            unblockPage();
            unblock('*');
          }
        }
      }, additionalButtons)
    });
  };

  let errorMultiMessage = (arr, callback) => {
    const tmpl = require('./tmpl/multi-message.hbs');
    bootbox.dialog({
      message: tmpl(arr),
      size: 'lg',
      closeButton: false,
      className: 'modal-header-inside',
      buttons: {
        Ok: {
          label: $lang.btn.gotIt,
          className: 'btn btn-brand',
          callback: function () {
            UI.btn.spinnerStopAll();
            if (callback) callback();
            unblockPage();
            unblock('*');
          }
        }
      }
    });
  };

  let deleteConfirm = (
    text = '',
    title = 'Delete',
    message = $Lang.alert.WantDelete,
    okLabel = $lang.btn.delete,
    cancelLabel = $lang.btn.cancel
  ) => {
    return new Promise((resolve, reject) => {
      bootbox.dialog({
        title: title,
        //closeButton: false,
        message: `<h5 class="my-4">${message} ${text}?</h5>`,
        className: 'modal-danger deletemessage-dialog-modal',
        onEscape: () => {
          return reject('User close');
        },
        buttons: {
          Ok: {
            label: okLabel,
            className: 'btn btn-danger bbw-border-radius',
            callback: function (e) {
              return resolve(true);
            }
          },
          cancel: {
            label: cancelLabel,
            className: 'btn btn-hover-dark bbw-border-radius',
            callback: function (e) {
              return reject('User close');
            }
          }
        }
      });
    });
  };

  let notify = ({ text = false, icon = false, type = 'info', delay = 5000 } = {}) => {
    if (!text) return;
    let t = {
      message: `${text}`
    };
    if (icon) t.icon = `${icon} fa-2x mr-3`;
    $.notify(t, {
      type: type,
      delay: delay,
      z_index: 99999
    });
  };

  let scrollToInvalid = () => {
    $('.form-control.is-invalid').focus();
    if ($('.is-invalid').length) {
      const invalid = $('.is-invalid').first();
      // If in tab set visible
      const tab = invalid.closest('.tab-pane');
      if (tab.length) {
        if (!tab.is(':visible')) {
          $(`a[href="#${tab.attr('id')}"]`).tab('show');
        }
      }
      let offset = invalid.offset().top;
      if (offset === 0) {
        offset = invalid.closest('.form-group').offset().top;
      }
      $('html, body').animate({ scrollTop: offset - 70 }, 'fast');
    }
  };

  let scrollToElement = (selector) => {
    const elem = $(`${selector}:visible`).first();
    if (!elem.offset()) {
      return;
    }

    elem.focus();
    $('html, body').animate({ scrollTop: elem.offset().top - 80 }, 'fast');
  };

  let modalFix = () => {
    $(document)
      .on('show.bs.modal', '.modal', function () {
        let zIndex = 1040 + 10 * $('.modal:visible').length;
        $(this).css('z-index', zIndex);
        setTimeout(function () {
          $('.modal-backdrop')
            .not('.modal-stack')
            .css('z-index', zIndex - 1)
            .addClass('modal-stack');
        }, 0);
      })
      .on('shown.bs.modal', '.modal', function () {
        onModalInit();
      });
    $(document).on('hidden.bs.modal', '.modal', function () {
      $('.modal:visible').length && $(document.body).addClass('modal-open');
    });

    $(document).on('click', '.dropdown-menu.keep-open', function (e) {
      e.stopPropagation();
    });
  };

  let setAsideMenuActive = () => {
    let page = document.location.pathname;
    let url = page.split('/')[1] || $config.routing.startpage;
    let wraper = $('#kt_aside_menu_wrapper');
    let navItem = $(`a[href="/${url}"]`, wraper).length
      ? $(`a[href="/${url}"]`, wraper)
      : $(`a[data-page~="${url}"]`, wraper).length
      ? $(`a[data-page~="${url}"]`, wraper)
      : false;
    $('.kt-menu__item--active', wraper).removeClass('kt-menu__item--active');
    //$('.kt-menu__item--open', wraper).removeClass('kt-menu__item--open');
    if (navItem) {
      if (navItem.length > 1) {
        let action = page.split('/')[2];
        navItem = $(`a[data-page~="${url}"][data-action~="${action}"]`, wraper);
      }
      navItem.closest('.kt-menu__item').addClass('kt-menu__item--active');
      navItem.closest('.kt-menu__item--submenu').addClass('kt-menu__item--open').addClass('kt-menu__item--active');
    }
  };

  let onPageWrapInit = () => {
    KTLayout.init();
    dataBinder.dataBind(document.body, window);
    // TODO UPDATE Rout
    //$router.updatePageLinks();
    asideToggler();
    $('body').off('click', markItem).on('click', markItem);
  };

  let onModalInit = () => {
    dataBinder.dataBind(document.body, window);
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
  };

  let asideToggler = () => {
    let asideToggle = Cookies.get('kt_aside_toggle_state');
    if (asideToggle && asideToggle == 'on') {
      $('body').addClass('kt-aside--minimize');
      $('#kt_aside_toggler').addClass('kt-aside__brand-aside-toggler--active');
    }
  };

  let asideToggleOn = () => {
    $('body').addClass('kt-aside--minimize');
    $('#kt_aside_toggler').addClass('kt-aside__brand-aside-toggler--active');
    Cookies.set('kt_aside_toggle_state', 'on');
  };

  let onPageLeaveHandler = () => {
    if ($config.APP_REACT) {
      return;
    }
    //$router.pause(true);
    $('body').attr('onpage-leave-active', true);
    $('[data-navigo]').on('click', linkHandler);
  };

  let offPageLeaveHandler = () => {
    if ($config.APP_REACT) {
      return;
    }
    //$router.pause(false);
    $('body').attr('onpage-leave-active', false);
    $('[data-navigo]').off('click', linkHandler);
  };

  let linkHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let elem = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
    leavePageDialog(elem.attr('href'));
  };

  let leavePageDialog = (path, callback = false, cancelCallback) => {
    if (!callback) history.back();
    bootbox.dialog({
      title: 'Leave page',
      closeButton: false,
      message: `<h5>Are you sure you want to leave this page?<br>All unsaved data will be lost.</h5>`,
      className: 'modal-danger',
      buttons: {
        Ok: {
          label: 'OK',
          className: 'btn btn-danger',
          callback: function () {
            if (callback) {
              offPageLeaveHandler();
              callback();
            } else {
              offPageLeaveHandler();
              //$router.navigate(path);
            }
          }
        },
        Cancel: {
          label: 'Cancel',
          className: 'btn btn-link',
          callback: function () {
            if (cancelCallback) {
              cancelCallback();
            }
          }
        }
      }
    });
  };

  let handlePageLeaveActive = (path, callback) => {
    if ($('body').attr('onpage-leave-active') !== 'true') {
      return false;
    }
    leavePageDialog(path, callback);
    return true;
  };

  let markItem = (e) => {
    let page = document.location.pathname.split('/')[1];
    if (!page) return;
    let item = $(e.target).closest('[data-itemid]');
    let storageKey = 'markitem_' + page;

    let milk = $(e.target).closest('#page').length || $(e.target).closest('#kt_header').length;

    if (item.length && item.data('itemid')) {
      // Mark item
      $('.box.marked-box').removeClass('marked-box');
      $('.box', item).addClass('marked-box');
      $storage.set(storageKey, item.data('itemid'));
    } else if (milk && $('body').attr('current-page') == $('body').attr('current-action')) {
      // Unmark item if catalog page && clicked on "milk"
      $('.box.marked-box').removeClass('marked-box');
      if ($storage.isSet(storageKey)) $storage.remove(storageKey);
    }
  };

  let markedItem = () => {
    let page = document.location.pathname.split('/')[1];
    if (!page) return;
    let storageKey = 'markitem_' + page;
    if ($storage.isSet(storageKey)) {
      let itemId = $storage.get(storageKey);
      $(`[data-itemid="${itemId}"] .box`).addClass('marked-box');
    }
  };

  let thumbnail = (data) => {
    if (!data) {
      return `<div class="table-thumbnail" style="background-image:url('/media/icons/file-image-light.svg')"></div>`;
    }
    let uri;
    try {
      uri = new URL(data).searchParams.get('Uri') || new URL(data).searchParams.get('FileName');
    } catch (err) {
      return `<div class="table-thumbnail" style="background-image:url(${data})"></div>`;
    }
    if (uri) {
      try {
        uri = new URL(uri).pathname.split('/');
      } catch (err) {}

      let fileName = Array.isArray(uri) ? uri[uri.length - 1] : uri;
      let type = Common.fileType(fileName);
      if (type == 'image') {
        return `<a href="${data}" class="magnific-image table-thumbnail bg-chess"><div style="background-image:url('${data}')"></div></a>`;
      } else if (type == 'font') {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fas fa-font"></i></a>`;
      } else if (type == 'svg') {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fal fa-file-code"></i></a>`;
      } else if (type == 'pdf') {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fal fa-file-pdf"></i></a>`;
      } else if (type == 'psd') {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fal fa-file-image"></i></a>`;
      } else if (type == 'tif') {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fal fa-file-image"></i></a>`;
      } else if (type == 'ai') {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fal fa-file-chart-line"></i></a>`;
      } else {
        return `<a href="${data}" target="_blank" class="table-thumbnail"><i class="fal fa-file"></i></a>`;
      }
    }
    return `<div class="table-thumbnail" style="background-image:url(${data})"></div>`;
  };

  /*
   *  @param {string} imageDataName - tag data name without data- :  <div data-zoomimage="..."></div>   -- @param is "zoomimage"
   */
  let zoomInInit = (imageDataName) => {
    $(`[data-${imageDataName}]`).each(function () {
      let url = $(this).data(imageDataName);
      if (url) {
        $(this)
          .zoom({
            url: url
          })
          .magnificPopup({
            items: { src: url },
            type: 'image'
          });
      }
    });
  };

  let zoomReInit = (el, url) => {
    el.trigger('zoom.destroy');
    el.css({ backgroundImage: `url("${url}")` })
      .data('zoomimage', url)
      .zoom({
        url: url
      })
      .magnificPopup({
        items: { src: url },
        type: 'image'
      });
  };

  let initGallery = (galleryContainerSelector) => {
    $(galleryContainerSelector).each(function () {
      $(this).magnificPopup({
        delegate: 'a',
        gallery: {
          navigateByImgClick: false,
          enabled: true,
          tCounter: '',
          tPrev: '',
          tNext: '',
          arrowMarkup:
            '<button type="button" class="mfp-arrow mfp-arrow-%dir% mfp-prevent-close"><i class="far fa-fw fa-chevron-%dir% mfp-prevent-close"></i></button>'
        },
        callbacks: {
          change: function () {
            setTimeout(() => {
              if (!this.arrowLeft || !this.arrowRight) {
                return;
              }

              if (this.index === 0) {
                this.arrowLeft.hide();
              } else {
                this.arrowLeft.show();
              }

              if (Boolean(this.items) && this.index === this.items.length - 1) {
                this.arrowRight.hide();
              } else {
                this.arrowRight.show();
              }
            });
          },
          buildControls: function () {
            if (!this.arrowLeft || !this.arrowRight) {
              return;
            }

            this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
          }
        },
        type: 'image'
      });
    });
  }

  let zoomInInitGallery = (imageDataName, galleryContainerSelector) => {
    $(`[data-${imageDataName}]`).each(function () {
      let url = $(this).data(imageDataName);

      if (url) {
        $(this).zoom({ url: url });
      }
    });

    initGallery(galleryContainerSelector);
  };

  let reInitZoom = (el, url) => {
    el.trigger('zoom.destroy');
    el.css({ backgroundImage: `url("${url}")` })
      .data('zoomimage', url)
      .zoom({ url: url });

    el.parent().attr('href', url);
  };

  let reInitGallery = (galleryContainerSelector, urls) => {
    $(`${galleryContainerSelector} > a`).remove();

    if (urls && urls.length) {
      urls.forEach((url) => {
        $(galleryContainerSelector).append(`<a href="${url}" class="invisible"></a>`);
      })
    }

    initGallery(galleryContainerSelector);
  };

  const handlerPageAccessDenied = () => {
    // TODO Update routing
    //$router.navigate('/');
    window.alert('Access denied');
  };

  return {
    init,
    pagewrap,
    render,
    page,
    currentPageAttr,
    block,
    unblock,
    blockPage,
    unblockPage,
    btn,
    animation,
    alert,
    errorMessage,
    errorMultiMessage,
    deleteConfirm,
    notify,
    scrollToInvalid,
    scrollToElement,
    setAsideMenuActive,
    onPageLeaveHandler,
    offPageLeaveHandler,
    leavePageDialog,
    handlePageLeaveActive,
    thumbnail,
    zoomInInit,
    zoomReInit,
    zoomInInitGallery,
    reInitZoom,
    reInitGallery,
    asideToggleOn,
    handlerPageAccessDenied,
    addPngFileDialog
  };
})();

//export {UI};
